<template>
  <div class="row">
    <div class="wrapper col-md-3">
      <div v-if="USER_INFO.status === 'admin'" class="list">
        <ul class="list-group">
          <li
            class="list-group-item list-group-item-action p-0"
            v-if="USER_INFO.gruppa === 'super'"
          >
            <router-link to="/kabinet/close-site" exact class="nav-link"
              >доступ на сайт</router-link
            >
          </li>
          <!--<li
            class="list-group-item list-group-item-action p-0"
            v-if="USER_INFO.gruppa === 'super'"
          >
            <router-link
              to="/kabinet/admin/file-manager/"
              exact
              class="nav-link"
              >менеджер файлов</router-link
            >
          </li>-->
          <li class="list-group-item list-group-item-action p-0">
            <router-link to="/kabinet/users" exact class="nav-link"
              >пользователи</router-link
            >
          </li>
          <li class="list-group-item list-group-item-action p-0">
            <router-link to="/kabinet/blank" exact class="nav-link"
              >загрузка бланка</router-link
            >
          </li>
          <li class="list-group-item list-group-item-action p-0">
            <router-link to="/kabinet/upload-instr" exact class="nav-link"
              >загрузка/изменение номенклатуры по
              инструменту/запчастям</router-link
            >
          </li>
          <li class="list-group-item list-group-item-action p-0">
            <router-link to="/kabinet/stats" exact class="nav-link"
              >статистика по инструменту</router-link
            >
          </li>
          <li class="list-group-item list-group-item-action p-0">
            <router-link to="/kabinet/stats-sc" exact class="nav-link"
              >статистика по СЦ</router-link
            >
          </li>
          <!--<li class="list-group-item list-group-item-action p-0">
            <router-link to="/kabinet/upload-realization" exact class="nav-link"
              >загруженные реализации
            </router-link>
          </li>
          <li class="list-group-item list-group-item-action p-0">
            <router-link to="/kabinet/not-cod-in-sheme" exact class="nav-link"
              >схемы без кодов
            </router-link>
          </li>-->
          <li class="list-group-item list-group-item-action p-0">
            <router-link
              to="/kabinet/search-zap-in-repairs"
              exact
              class="nav-link"
              >поиск запчастей в ремонтах
            </router-link>
          </li>
          <li class="list-group-item list-group-item-action p-0">
            <router-link to="/kabinet/otpravki" exact class="nav-link"
              >отправки
            </router-link>
          </li>
          <li class="list-group-item list-group-item-action p-0">
            <router-link to="/kabinet/menedger-stats" exact class="nav-link"
              >статистика по менеджерам
            </router-link>
          </li>
        </ul>
      </div>
      <div v-else>
        <ul class="list-group">
          <li class="list-group-item list-group-item-action p-0">
            <router-link to="/kabinet/users/user/1" exact class="nav-link"
              >реквизиты</router-link
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="wrapper col-md-3">
      <div
        v-if="USER_INFO.gruppa === 'super'"
        class="list"
        data-toggle="modal"
        data-target="#exampleModal"
      >
        <ul class="list-group">
          <li class="list-group-item list-group-item-action p-0">
            <a href="" class="nav-link" @click.prevent="edit_recvizit"
              >реквизиты организации</a
            >
          </li>
          <li class="list-group-item list-group-item-action p-0">
            <router-link
              to="/kabinet/admin/repairs-report-period"
              exact
              class="nav-link"
              >отчет по ремонтам</router-link
            >
          </li>
        </ul>
      </div>
    </div>
    <router-view />
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Реквизиты организации
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="m-1">
              <input
                type="text"
                class="form-control shadow-none"
                v-model.trim="recvisit.name"
                placeholder="название организации"
                @input="data_change"
              />
            </div>
            <div class="m-1">
              <input
                type="text"
                class="form-control shadow-none"
                v-model.trim="recvisit.inn"
                placeholder="ИНН"
                @input="data_change"
              />
            </div>
            <div class="m-1">
              <input
                type="text"
                class="form-control shadow-none"
                v-model.trim="recvisit.adres"
                placeholder="юридический адрес"
                @input="data_change"
              />
            </div>
            <div class="m-1">
              <input
                type="text"
                class="form-control shadow-none"
                v-model.trim="recvisit.post_adres"
                placeholder="почтовый адрес"
                @input="data_change"
              />
            </div>
            <div class="m-1">
              <input
                type="text"
                class="form-control shadow-none"
                v-model.trim="recvisit.data_act"
                placeholder="запись в акте"
                @input="data_change"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary shadow-none"
              data-dismiss="modal"
            >
              Закрыть
            </button>
            <button
              type="button"
              class="btn btn-primary shadow-none"
              :disabled="button_save_disabled"
              @click="save_change"
            >
              Сохранить изменения
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { HTTPGET } from "@/api";
export default {
  name: "Kabinet",
  computed: {
    ...mapGetters(["USER_INFO"])
  },
  mounted() {},
  data: () => ({
    recvisit: [],
    recvisit_change: [],
    button_save_disabled: true
  }),
  methods: {
    get_recvizit_org() {
      HTTPGET({
        url: "/admin/recvizit_org/get_recvizit_org.php"
      }).then(response => {
        this.recvisit = response.data.set;
        this.recvisit_change = response.data.check;
      });
    },
    edit_recvizit() {
      this.get_recvizit_org();
    },
    data_change() {
      if (
        this.recvisit.name !== this.recvisit_change.name ||
        this.recvisit.inn !== this.recvisit_change.inn ||
        this.recvisit.adres !== this.recvisit_change.adres ||
        this.recvisit.post_adres !== this.recvisit_change.post_adres ||
        this.recvisit.data_act !== this.recvisit_change.data_act
      ) {
        this.button_save_disabled = false;
      } else {
        this.button_save_disabled = true;
      }
    },
    save_change() {
      HTTPGET({
        url: "/admin/recvizit_org/change_recvizit_org.php",
        params: this.recvisit
      })
        .then(() => this.get_recvizit_org())
        .then(() => (this.button_save_disabled = true));
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  margin: 5px;
}
ul {
  list-style: none;
}
</style>
